export const CONSOLE_METHODS = ["log", "info", "warn", "error", "debug"] as const;
export type ConsoleMethod = (typeof CONSOLE_METHODS)[number];

/**
 * The real `console.log/info/warn/error` methods, captured once at module load — before
 * `console-interceptor.ts` (or anything else) has a chance to patch `console`.
 *
 * Both the interceptor's passthrough and `Logger`'s own console mirroring call these directly
 * instead of `console[method]` itself, so neither path can ever re-enter the other. Previously,
 * `Logger.mirrorToConsole()` called the (already patched) `console[method]`, which re-triggered
 * the interceptor and produced duplicated, mislabeled `"[console] ..."` entries both on screen
 * and in `gciins-logs-db`; sharing these native references removes that recursion entirely.
 *
 * @see Docs/app-logs.md
 */
export const nativeConsole: Record<ConsoleMethod, (...args: unknown[]) => void> = {
  log: console.log.bind(console),
  info: console.info.bind(console),
  warn: console.warn.bind(console),
  error: console.error.bind(console),
  debug: console.debug.bind(console),
};
